<template>
  <RouterView />
</template>

<script setup>
    import { onMounted } from 'vue';

    onMounted(() => {
        document.querySelector("body")?.classList.add("theme-" + (localStorage.getItem('admin_theme') || "light"));
    })
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

//body {
//  margin: 0;
//  min-width: 20rem;
//
//    &.theme-light {/* Apply different background color to every second row */
//        .va-data-table__table-tr:nth-child(even) {
//            TD:not(.va-data-table__table-expanded-content) {
//                background-color: #eceded; /* light gray for even rows */
//            }
//
//        }
//
//        /* Optional: hovered row highlight */
//        .va-data-table__table-tr:hover {
//            // background-color: #edf1f7;
//        }
//    }
//
//    &.theme-dark {
//        /* Apply different background color to every second row */
//        .va-data-table__table-tr:nth-child(even) {
//            TD:not(.va-data-table__table-expanded-content) {
//                background-color: #151515; /* light gray for even rows */
//            }
//
//        }
//
//
//        /* Optional: hovered row highlight */
//        .va-data-table__table-tr:hover {
//            // background-color: rgba(30, 30, 30, 0.76);
//        }
//    }
//}
</style>
